import React, {createContext, useContext, useMemo, useState} from "react";
// import { initialFilters } from "../../../pages/ordersList/initials";

export const OrderFiltersDataContext = createContext(null);

const OrderFiltersDataProvider = props => {

    const [orderFilters, setOrderFilters] = useState({});

    const orderFiltersDataValue = useMemo(() => ({ orderFilters, setOrderFilters }), [orderFilters]);

    return  <OrderFiltersDataContext.Provider value={{ orderFiltersDataValue }} {...props} />
};

export const useOrderFiltersDataContext = () => useContext(OrderFiltersDataContext);
export default OrderFiltersDataProvider;